import pkg from 'package'

export default {
  theme: {
    color: 'indigo',
    colorHTML: '#3f51b5'
  },
  device: {
    isMobile: false,
    isTablet: false
  },
  pkg: {
    pkg: pkg
  }

}



// WEBPACK FOOTER //
// ./src/store/modules/app/state.js